import { employees } from "./data/generated";
import type { Employee, GeneratedMail } from "./types";

export function employeeById(id: string): Employee | undefined {
  return employees.find((employee) => employee.id === id);
}

export function senderName(mail: GeneratedMail): string {
  return mail.senderNameOverride ?? employeeById(mail.senderId)?.displayName ?? "不明な送信者";
}

export function senderEmail(mail: GeneratedMail): string {
  return mail.senderEmailOverride ?? employeeById(mail.senderId)?.email ?? "unknown@invalid";
}

export function displayDate(mail: GeneratedMail): string {
  if (mail.sentAtDisplayOverride) return mail.sentAtDisplayOverride;
  const date = new Date(mail.sentAt);
  if (Number.isNaN(date.getTime())) return mail.sentAt;
  return new Intl.DateTimeFormat("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  }).format(date);
}

export function formatDuration(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return `${minutes}:${rest.toString().padStart(2, "0")}`;
}
